import { Descriptions, Typography } from "antd";
import { Copyable } from "../../common/Copyable";
import WrappedCard from "../../antd/WrappedCard";

type InfoCardProps = {
  cardTitle: string;
  descTitle: string;
  itemList: {
    label: string;
    value?: string | number;
  }[];
};

const InfoCard = ({ cardTitle, descTitle, itemList }: InfoCardProps) => {
  return (
    <WrappedCard cardTitle={cardTitle}>
      <Descriptions title={descTitle} bordered>
        {itemList.map((item) => (
          <Descriptions.Item key={item.label} label={item.label}>
            <Typography.Title
              copyable={{ icon: <Copyable /> }}
              level={5}
              style={{ margin: 0 }}
            >
              {item.value}
            </Typography.Title>
          </Descriptions.Item>
        ))}
      </Descriptions>
    </WrappedCard>
  );
};

export default InfoCard;
